import * as React from 'react';
import { Button } from '@origin-digital/style-guide';
import { PasswordInput } from '../PasswordInput/PasswordInput';
import { HiddenAutofillInput } from '../HiddenAutofillInput/HiddenAutofillInput';
import { IError } from 'ts/login/interfaces';
import { LoginErrorBox } from '../LoginErrorBox';
import { Loader } from '../../../components/Loader';

interface QuickLoginFormViewProps {
  username: string;
  password: string;
  loginError: IError;
  loginSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  passwordError: string;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
}

const QuickLoginFormView: React.FC<QuickLoginFormViewProps> = ({
  loading,
  username,
  password,
  loginError,
  loginSubmit,
  passwordError,
  onPasswordChange,
}) => {
  return (
    <>
      {loading ? (
        <Loader height="500px" />
      ) : (
        <>
          <LoginErrorBox error={loginError} />
          <form onSubmit={loginSubmit}>
            <HiddenAutofillInput username={username} />
            <PasswordInput
              label={'Password'}
              value={password}
              error={passwordError}
              onChange={onPasswordChange}
            />
            <Button type="submit" data-id="login" text="Log in" name="login" block={true} />
          </form>
        </>
      )}
    </>
  );
};

export { QuickLoginFormView };
